export const products = [
  {
    id: 1,
    name: "হোমমেড সেরেলাক হাফ কেজি",
    price: 650,
    image: "/images/product-half-kg.jpg",
    freeItems: "ফ্রি ডেলিভারি",
    badge: null
  },
  {
    id: 2,
    name: "হোমমেড সেরেলাক এক কেজি",
    price: 1100,
    image: "/images/product-one-kg.jpg",
    freeItems: "২০০ গ্রাম খিচুড়ি + ২০০ গ্রাম তাল মিছরি ফ্রি + ফ্রি ডেলিভারি",
    badge: "সবচেয়ে জনপ্রিয়"
  },
  {
    id: 3,
    name: "হোমমেড সেরেলাক ২ কেজি",
    price: 2100,
    image: "/images/product-two-kg.jpg",
    freeItems: "হাফ কেজি রাজমা খিচুড়ি ফ্রি + ফ্রি ডেলিভারি",
    badge: "সেরা অফার"
  }
];
